import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

export default function Image({ image, alt = '', ...rest }) {
  if (image === undefined) return null;
  if (typeof image === 'string') {
    return <img loading="lazy" src={image} {...rest} alt={alt} />;
  }
  if (!image.childImageSharp) {
    return <img loading="lazy" src={image.publicURL} {...rest} alt={alt} />;
  }
  const imageOptimized = getImage(image);
  return <GatsbyImage image={imageOptimized} {...rest} alt={alt} />;
}
